<template>
    <div class="noneData">
         <img src="@/assets/img/notData/404.png" alt="">
         <p>该课程已下架，无法查看</p>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
    }
</script>

<style lang="scss" scoped>
.noneData{
    height: 100vh;
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
        width: 180px;
        height: 180px;
    }
    p{
        margin-top: 8px;
        color: #86878A;
        font-size: 14px;
        line-height: 20px;
    }
}

</style>